
// console.log('start main');
"use strict";
let startChat = document.querySelectorAll('.start-chat'),
    comingSoon = document.querySelectorAll('a.comingsoon'),
    pdfArr = $('.pdf-list a'),
    pdfArrL = pdfArr.length,
    pdfLinkSingle,
    langCode = document.getElementById('langdrop')?.getAttribute('data-lang-code'),
    windowWidth = $(window).width(),
    scriptTag,
    wLoc = window.location.pathname,
    DATA = 'D7WBWOWdDAWRW3WBDQWlDQDAWhDADQDTDpIYDzWvDXWcDADNIEIuIcWiDCWTDWWSWKWDDLDYW6WKWdWiIcWRIEWhWdD8IEWfIEWlDWWEIcDf',
    MOBSIZE = 767,
    supportNumber = 82;

Array.prototype.forEach.call(comingSoon, function (el) {
    el.addEventListener('click', function () {
        alert('Coming soon');
        event.preventDefault();
    });
});

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
function getMobileOperatingSystem() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

//checking for translation pdf files on server

function send() {

    pdfLinkSingle = pdfArr[i].getAttribute('href').slice(0, -4) + '_' + langCode + '.pdf';

    $.ajax({
        type: "HEAD",
        url: pdfLinkSingle,
        success: function () {
            pdfArr[i].setAttribute('href', pdfLinkSingle);
            i++;
            if (i < pdfArrL) send();
        },
        error: function () {
            i++;
            if (i < pdfArrL) send();
        }
    });

}

/*! --test */

// $(document).ready(function() {
//     // $('#b1 .btn').click();
// });

$(document).ready(function () {

    if (pdfArrL && (langCode !== 'en')) {
        setTimeout(send, 1000);
    }

    if ($("#verif").prop("checked")) $(".youQuart").addClass("verif");

    $(".panel.left .item").on("mouseover click", function () {
        let par = $(this).attr('data-target');
        $('.panel.right .tab-pane img').css({ 'opacity': 0 });
        $('.panel.right [role="tabpanel"]').removeAttr('data-viz').attr('data-viz', par);
        $('.panel.left').removeAttr('data-viz').attr('data-viz', par);

        $(".panel.left .item").on("mouseout", function () {
            $('.panel.right [role="tabpanel"]').removeAttr('data-viz');
            $('.panel.left').removeAttr('data-viz');
        })
    });

    //!3 комисии к конвертеру
    /*! --test */

    // // Swiss and Frontaliers
    // function calcwid() {
    //     if ($('#calcwid')[0]) {
    //         // console.log("есть виджет");
    //         // console.log($('#calcwid'));
    //         let swsresidlist = $('#contList').attr('data-contrlist');
    //         let swsresident = swsresidlist.split(',');
    //         // console.log(swsresident);
    //         let curCh = 0.005;
    //         // console.log(curCh);
    //         let body_ccode = $('body').attr('data-ccur');
    //         // console.log(body_ccode);
    //         if (body_ccode === 'ccode-CH') {
    //             curCh = 0.0025;
    //         } else {
    //             for (let i = 0; i < swsresident.length; i++) {
    //                 if ('ccode-' + swsresident[i] === body_ccode) {
    //                     curCh = 0.005;
    //                     // console.log(curCh);
    //                 }
    //             }
    //         }
    //         // console.log(curCh);
    //         document.getElementById("calcwid").contentWindow.curcon.setCommission(curCh);
    //     }
    //     // else console.log("нет виджета");
    // }
    // setTimeout(calcwid, 2000);

    // $('.change-residents').change(function () {
    //     let curCh = $(this).val();
    //     console.log(curCh);
    //     document.getElementById("calcwid").contentWindow.curcon.setCommission(curCh);
    // });
    // END Swiss and Frontaliers

    // подсветка
    let menu_selector = ".left-menu"; // Переменная должна содержать название класса или идентификатора, обертки нашего меню.

    function onScroll() {
        let scroll_top = $(document).scrollTop();
        $(menu_selector + " a").each(function () {
            let hash = $(this).attr("href");
            let target = $(hash);
            if (target.position().top <= (scroll_top + 60) && target.position().top + target.outerHeight() > (scroll_top + 60)) {
                $(menu_selector + " a.focus").removeClass("focus");
                $(this).addClass("focus");
            } else {
                // $(this).removeClass("focus");
            }
        });
    }

    $(document).on("scroll", onScroll);

    document.querySelectorAll("a[href*='#']").forEach(function(anchor) {

        if (anchor.href.replace(anchor.hash, '') === window.location.href.replace(window.location.hash, '')) {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();

                let targetId = this.getAttribute("href").split('#')[1];
                let target = document.getElementById(targetId);



                if (!target) return; // If the target element is not found, exit

                if (this.closest('.etf-product nav.nav')){
                    //console.log('nav.nav');
                    return;
                }

                // If the click is on an element from the left menu
                if (this.closest('.left-menu')) {
                    // Remove the 'focus' class from all menu elements and add it to the current one
                    document.querySelectorAll("a.focus").forEach(function (focusEl) {
                        focusEl.classList.remove("focus");
                    });
                    this.classList.add("focus");
                    document.querySelectorAll('.drop .head').forEach(function (head) {
                        head.dispatchEvent(new CustomEvent('hide.bs.accardion'));
                    });
                    let targetHead = target.querySelector('.head');
                    if (targetHead) {
                        targetHead.dispatchEvent(new CustomEvent('shown.bs.accardion'));
                    }
                    target.dispatchEvent(new CustomEvent('shown.bs.accardion'));
                }

                console.log(target);

                // Scroll animation to the target
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth'
                });

                // Hide the header after scrolling
                setTimeout(function () {
                    headerController.hideHeader();
                }, 500);
            });
        }
    });

    let params = window
        .location
        .search
        .replace('?', '')
        .split('&')
        .reduce(
            function (p, e) {
                let a = e.split('=');
                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                return p;
            },
            {}
        );

    console.log(params);

    if (params['getloc'] !== undefined) {


        // console.log($('[data-target="#' + params.getloc+'"]'));
        if (!!$("#" + params['getloc'])[0]) {
            if (!!$('body.faq')[0]) {

                $('.accordion .head').removeClass('open');
                $('.accordion .wrap').removeClass('open').css('--h', 0);

                $('[data-target="#' + params.getloc + '"]').click();

                oftotop = $("#" + params['getloc']).offset().top - 210;
            }

            if (!!$('body.fees')[0]) {

                $('.accordion .drop').removeClass('open').css('--h', 0);

                $('#' + params.getloc + ' .head').click();

                oftotop = $("#" + params['getloc']).offset().top - 110;

            }

            setTimeout(function () {

                $('body,html').animate({ scrollTop: oftotop }, 'slow');

                // console.log(oftotop);
            }, 500)
        }

    }

    if (!!$('body.fees')[0]) {
        $(".accordion .head").on("click", function () {

            let $aim = 'https://www.dukascopy.bank/swiss/fees/?getloc=' + $(this).parent()[0].id;
            // console.log($aim);

            navigator.clipboard.writeText($aim);
            // console.log('copy ' + $aim);
        });
    }

    if (!!$('body.faq')[0]) {
        $(".accordion .head").on("click", function () {

            let $aim = 'https://www.dukascopy.bank/swiss/faq/?getloc=' + ($(this).data('target')).substring(1);
            // console.log($aim);

            navigator.clipboard.writeText($aim);
            // console.log('copy ' + $aim);
        });
    }


    const hashMap = {
        'accFees': 'acc-fees',
        'acc-fees':'acc-fees',
        'tranFees': 'trans-fees',
        'trans-fees': 'trans-fees',
        'dukascopy-card': 'dukascopy-card',
        'DukascopyCard': 'dukascopy-card',
        'cardFees': 'dukascopy-card',
        'SwissBankersCard': 'swiss-bankers-card',
        'swiss-bankers-card': 'swiss-bankers-card',
        'WallettoCard': 'walletto-card',
        'walletto-card': 'walletto-card',
        'cbh-card': 'cbh-card',
        'cbhCard': 'cbh-card',
        'privAcc': 'priv-acc',
        'priv-acc': 'priv-acc',
        'other-fees': 'other-fees',
        'invest': 'invest',
        'dukascopy-and-swiss-bankers-cards': 'payment-cards',
        'payment-cards': 'payment-cards',
        'faq01': 'multi-currency-account',
        'faq16': 'account-opening',
        'faq02': 'my-account',
        'faq03': 'account-limits',
        'faq04': 'payment-operations',
        'faq07': 'payment-cards',
        'faq14': 'partner-account',
        'faq18': 'private-banking-savings-account',
        'faq13': 'investments',
        'faq17': 'dukascoins',
        'faq12': 'dukascopy-connect-911',
        'faq19': 'referral-program',
    }

    let h = document.location.hash;
    if (h !== undefined && h != null) {
        console.log(h);
        h = h.replace('#', '');
        if (hashMap[h] !== undefined) {

            console.log(hashMap[h]);

            $('.drop .head').trigger('hide.bs.accardion');
            $('#' + hashMap[h] + ' .head').trigger('shown.bs.accardion');

            setTimeout(function () {
                // $("#" + params['getloc']);
                let oftotop = $("#" + hashMap[h]).offset().top - 110;

                $('body,html').animate({ scrollTop: oftotop }, 'slow');
                console.log(oftotop);
            }, 500)
        }
    }
    // подсветка конец




    if (parseParam('pwdreset', 1)) {

        if (location.pathname.indexOf('swiss') > -1) {
            messagePop('<p>' + $('#miscMessages div#pwdRstP1').html() + '</p><p>' + $('#miscMessages div#pwdRstP2').html() + '</p>');
        } else {
            messagePop('<p>' + $('#miscMessages div#pwdRstP1').html() + '</p><p>' + $('#miscMessages div#pwdRstP2EU').html() + '</p>');
        }
    }

    function parseParam(param, val) {
        let tmp = [];
        let items = location.search.substr(1).split("&");
        for (let index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if ((tmp[0] === param) && (tmp[1] === val)) {
                return true;
            }
        }
        return false;
    }

    function messagePop(stringHTML) {
        let popUp = document.createElement('div');

        popUp.id = 'pop-message';
        popUp.innerHTML = '<div class="pop-up-bg close-popup"></div><div class="pop-up-inner">' + stringHTML + '<br><button class="close-popup btn">' + $('#miscMessages div#pwdRstCLOSE').html() + '</button><button class="close-popup btn-close"></button></div>';
        document.body.appendChild(popUp);

        $('.close-popup').on('click', function () {
            $('#pop-message').fadeOut(300);
            setTimeout(function () {
                $('#pop-message').remove();
            }, 500);
        });
    }

    if ($('body').hasClass('opacc')) {
        let params = new URLSearchParams(location.search);
        let ref = params.get("ref");
        let re = /[0-9A-Z]{3}-[0-9A-Z]{3}/i;
        //console.log(re.test(ref));
        console.log(ref);
        if (ref !== null) {
            if (ref.length === 7 && re.test(ref) !== false) {
                $('.hero').find('.noref').css({ 'display': 'none' });
                $('.hero').find('.code').text(ref);
                $('.hero').find('.ref').removeAttr('style');
            }
        }

        if (params.get("utm_campaign") > 0) {
            console.log(params.get("utm_campaign"));

            setTimeout(function () {
                $('#openModal2').click();
            }, 15000);
        }

    }

    // if ($(window).width() > 1023)
    $('.select select').select2();

    if ($('.select2-results')[0]) new SimpleBar($('.select2-results__options')[0]);



});


$('.start-chat').on('click', () => {
    $('#btnExecute').addClass('loading');
    DCC_loadChat();
});

function onDCC_ChatLoaded() {
    $('#btnExecute').removeClass('loading');
    $('.start-chat').off('click');
    $('.start-chat').on('click', () => {
        DCC_openChat();
    });
}